jQuery(function(){

  
  if( $('#SingleOptionSelector-2 option').length == 1 ){
    $('#SingleOptionSelector-2').hide();
    $("label[for='SingleOptionSelector-2']").hide();
  }

function updateSpec(){
  var altSpec = false;
  var title = jQuery("#product_title").html();
  
  var spec = jQuery("#SingleOptionSelector-2").val();

  
  
  
  
  
  
  var title = jQuery("#product_title").html();
  if(title.length > 30){
    var newTitle = title.substring(0, 30);
    var allTheSpecs = JSON.parse(specJSON[newTitle]);
  }else{
    var allTheSpecs = JSON.parse(specJSON[title]);
  }
  
  //placeholder for any additional spec options 
  var extraSpecInfo;

  
  if( spec.indexOf('2.6') > 0 ){
    extraSpecInfo = "(2.6)";
  }else if(spec.indexOf('Air') > 0){
    extraSpecInfo = "(Air Shock)";
  }else if(spec.indexOf('Coil') > 0){
    extraSpecInfo = "(Coil Shock)";
  }
  else if(spec.indexOf('650b') > 0){
    extraSpecInfo = "(650b)";
  }else if(spec.indexOf('700C') > 0){
    extraSpecInfo = "(700C)";
  }else{
    extraSpecInfo = " ";
  }
  
  if(title.indexOf('Squatch')){
    
  	if( spec.indexOf('AM') > -1 ){
    extraSpecInfo = "AM";
  }else if(spec.indexOf('PRO 175') > -1){
    extraSpecInfo = "PRO 175";
  }else if(spec.indexOf('Pro 200') > -1){
    extraSpecInfo = "Pro 200";
  }
  }
  
  
 
  jQuery("#productDescriptionTitle").html(title + " " + extraSpecInfo);
  
  //update each span in the table
  jQuery("#spec-fork").html(allTheSpecs[spec].Fork);
  jQuery("#spec-shock").html(allTheSpecs[spec].Shock);
  jQuery("#spec-mech").html(allTheSpecs[spec]["Rear Derailleur"]);
  jQuery("#spec-shifter").html(allTheSpecs[spec].Shifters);
  jQuery("#spec-cranks").html(allTheSpecs[spec].Crankset);
  jQuery("#spec-cassette").html(allTheSpecs[spec].Cassette);
  jQuery("#spec-chain").html(allTheSpecs[spec].Chain);
  jQuery("#spec-brakes").html(allTheSpecs[spec].Brakes);
  jQuery("#spec-rotors").html(allTheSpecs[spec].Rotors);
  jQuery("#spec-bars").html(allTheSpecs[spec].Handlebars);
  jQuery("#spec-stem").html(allTheSpecs[spec].Stem);
  jQuery("#spec-grips").html(allTheSpecs[spec].Grips);
  jQuery("#spec-headset").html(allTheSpecs[spec].Headset);
  jQuery("#spec-seatpost").html(allTheSpecs[spec].Seatpost);
  jQuery("#spec-saddle").html(allTheSpecs[spec].Saddle);
  jQuery("#spec-f-tyre").html(allTheSpecs[spec]["Front Tyre"]);
  jQuery("#spec-r-tyre").html(allTheSpecs[spec]["Rear Tyre"]);
  jQuery("#spec-f-hub").html(allTheSpecs[spec]["Front Hub"]);
  jQuery("#spec-r-hub").html(allTheSpecs[spec]["Rear Hub"]);
  jQuery("#spec-rims").html(allTheSpecs[spec].Rims);
  jQuery("#spec-spokes").html(allTheSpecs[spec].Spokes);
  
  if(allTheSpecs[spec].Battery){
  
      jQuery("#spec-battery").html(allTheSpecs[spec].Battery);
      jQuery("#spec-drive-unit").html(allTheSpecs[spec]["Drive Unit"]);
      jQuery("#spec-display").html(allTheSpecs[spec].Display);
      jQuery("#spec-remote").html(allTheSpecs[spec].Remote);
      jQuery("#spec-charger").html(allTheSpecs[spec].Charger);
  
  }

  
}



updateSpec();

jQuery("#SingleOptionSelector-2").change(function(){
	//console.log("you have changed the spec");
  	updateSpec();
});
  
jQuery("#SingleOptionSelector-1").change(function(){
	//console.log("you have changed the spec");
  	updateSpec();
});

  
  
//MY21 Specific  
  
  var startingPosition = $('#bbmy21-titleNav').offset().top;
  var navHeight = $('#bbmy21-titleNav').height();

  //set buff height, keep hidden
  
  $("#bbmy21-stickyNavBuff").css({"height": navHeight + "px"});
  
  
// scroll functions - sticky menu
  
  $( window ).scroll(function() {
    
    var scrollTop     = $(window).scrollTop(),
      	elementOffset = $('#bbmy21-titleNav').offset().top,
      	distance      = (elementOffset - scrollTop);
    	
    
    if(scrollTop >= startingPosition){
      $("#bbmy21-titleNav").addClass("bbmy21-sticky-menu").removeClass('bbmy21-floaty-menu');
      $("#bbmy21-stickyNavBuff").show(0);
    }else if(scrollTop < startingPosition){
      $("#bbmy21-titleNav").removeClass("bbmy21-sticky-menu").addClass('bbmy21-floaty-menu');
      $("#bbmy21-stickyNavBuff").hide(0);
    }

    

  });
  

  $("#bbmy21_toggle-delivery").click(function(){
   
    
    
    if ( $("#bbmy21_warranty-info-body").is(":visible") ){
      //if it is get rid
      $("#bbmy21_warranty-info-body").toggle();
      //and update text in warranty button
      $("#bbmy21_toggle-warranty").text('Hide Warranty Info');
    }
    
    if ( $("#bbmy21_delivery-info-body").is(":visible") ){
      $("#bbmy21_toggle-delivery").text('Show Delivery Info');
    
    }else{
      $("#bbmy21_toggle-delivery").text('Hide Delivery Info');
    }

    $("#bbmy21_delivery-info-body").toggle();
      //and update text in warranty button
      
  
  })
  
  $("#bbmy21_toggle-warranty").click(function(){
   
    
    
    if ( $("#bbmy21_delivery-info-body").is(":visible") ){
      //if it is get rid
      $("#bbmy21_delivery-info-body").toggle();
      //and update text in warranty button
      $("#bbmy21_toggle-delivery").text('Hide Delivery Info');
    }
    
    if ( $("#bbmy21_warranty-info-body").is(":visible") ){
      $("#bbmy21_toggle-warranty").text('Show Warranty Info');
    
    }else{
      $("#bbmy21_toggle-warranty").text('Hide Warranty Info');
    }

    $("#bbmy21_warranty-info-body").toggle();
      //and update text in warranty button
      
  
  })
  

  $(".bbmy21-nav-btn").click(function(){

  	var target = $(this).attr('data-target');
    
    $('html,body').animate({
      scrollTop: $('.'+target+':first').offset().top - (navHeight + 30)
	},500);
  })
  
  //check if page is scrolled on load and fix sticky nav if so
  
  var bottomOfHero = $('#bbmy21-hero-container').height();
  
  if ($(window).scrollTop() > bottomOfHero){
    $("#bbmy21-titleNav").addClass("bbmy21-sticky-menu").removeClass('bbmy21-floaty-menu');
      $("#bbmy21-stickyNavBuff").show(0);
  }
  
  
  
  
  

});